import React, { Fragment } from "react";
import "./DieInput.scss";

import DieIcon from "./DieIcon";
import { Die } from "../models/messages";

interface Props {
  die: Die;
  onDieCountChange: (count: number) => void;
}

export default function DieInput(props: Props) {
  const { die, onDieCountChange } = props;

  return (
    <div className="flex-grow-1 d-flex my-2 mx-2 align-items-center justify-content-center">
      <div className="c-die-input input-group  input-group ">
        <div className="input-group-prepend ">
          <span className="input-group-text bg-dark" id="basic-addon1">
            <DieIcon die={die} />
          </span>
        </div>
        <input
          type="number"
          className="form-control bg-transparent text-light text-center"
          placeholder="0"
          min="0"
          max="20"
          onChange={(e) => onDieCountChange(+e.target.value)}
        />
      </div>
    </div>
  );
}
